import React from 'react';
import { Skeleton } from '@material-ui/lab';
// indent level and label width per row, so it reads like a folder tree
const rows = [[0, 70], [1, 60], [1, 75], [2, 55], [2, 65], [1, 50], [0, 80], [1, 60], [0, 65], [1, 70], [1, 55], [0, 60]];
const STreeLoader = ({count = rows.length}) => {
  return(
    <div className="dm-folder-tree-loader">
      {rows.slice(0, count).map(([level, width], index) =>
        <div key={index} className="flex-centered" style={{ paddingLeft: 10 + level * 16 + 'px', height: '28px' }}>
          <Skeleton variant="rect" animation="wave" width={15} height={13} style={{ borderRadius: '2px', marginRight: '8px', flexShrink: 0 }} />
          <Skeleton variant="text" animation="wave" width={width + '%'} height={16} />
        </div>
      )}
    </div>
  )
}
export default STreeLoader;
